import React, { useEffect } from 'react';
import { TaxTypeFormPropTypes } from '../shapes';

export const EmptyTaxForm = ({ onValidate, taxFormat }) => {
  useEffect(() => {
    onValidate({ data: null, taxCertification: null, isValid: true });
  // callback validation result when component did mount.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [taxFormat]);

  return (<div />);
};

EmptyTaxForm.propTypes = TaxTypeFormPropTypes;
